import { User } from 'oidc-client-ts';

export const getToken = () => {
  const loggedInUser = sessionStorage.getItem(
    `oidc.user:${import.meta.env.VITE_REACT_APP_AUTHENTICATION_URL}:${
      import.meta.env.VITE_REACT_APP_AUTHENTICATION_CLIENT_ID
    }`
  );

  if (loggedInUser) {
    return (JSON.parse(loggedInUser) as User)?.id_token;
  }

  return '';
};
